module.exports = __webpack_public_path__ + "static/3-0fd6acff3bb1dbe325ecd206d9ce430a.jpg";